import { render } from "./Delivery_Order_Details.vue?vue&type=template&id=1c7a0b85"
import script from "./Delivery_Order_Details.vue?vue&type=script&lang=js"
export * from "./Delivery_Order_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__